import { withStyles } from '@ellucian/react-design-system/core/styles';
import {
    borderWidthThick,
    colorBorderGlobalFocus,
    colorGlobalBorderDefault,
} from '@ellucian/react-design-system/core/styles/tokens';
import classnames from 'classnames';
import React = require('react');
import absolutePosition from './absolutePosition';

interface ILine {
    baseline: string;
    classes: any;
    className?: string;
    end: string;
    selected?: boolean;
    orientation: 'bottom' | 'top';
    start: string;
}

const styles = () => ({
    bottom: {
        '&.selected': {
            borderBottom: `${borderWidthThick} solid ${colorBorderGlobalFocus}`,
        },
        'borderBottom': `${borderWidthThick} solid ${colorGlobalBorderDefault}`,
    },
    left: {
        '&.selected': {
            borderLeft: `${borderWidthThick} solid ${colorBorderGlobalFocus}`,
        },
        'borderLeft': `${borderWidthThick} solid ${colorGlobalBorderDefault}`,
    },
    line: {
        position: 'absolute',
        zIndex: 1,
    },
    top: {
        '&.selected': {
            borderTop: `${borderWidthThick} solid ${colorBorderGlobalFocus}`,
        },
        'borderTop': `${borderWidthThick} solid ${colorGlobalBorderDefault}`,
    },
});

const attr = 'data-line-id';
const selector = (value) => `[${attr}='${value}']`;

export class LineInner extends React.Component<ILine, any> {
    public static defaultProps = {
        selected: false,
    };

    constructor(props: ILine) {
        super(props);

        this.state = {
            style: {},
        };

        this.updateDimensions = this.updateDimensions.bind(this);
    }

    public updateDimensions() {
        const start = document.querySelector(selector(this.props.start));
        const end = document.querySelector(selector(this.props.end));
        const baseline = document.querySelector(selector(this.props.baseline));

        if (start && end && baseline) {
            const baselineRect = absolutePosition(baseline);
            const startRect: any = absolutePosition(start);
            const endRect: any = absolutePosition(end);

            let left;
            let top;
            let height;
            let width;

            let absoluteTop;
            let absoluteLeft;

            if (this.props.orientation === 'top') {
                absoluteLeft = startRect.left + ( startRect.width / 2 );
                left = (startRect.left - baselineRect.left) + ( startRect.width / 2 );
                absoluteTop = (endRect.top) + ( endRect.height / 2 ) - 2;
                top = (endRect.top - baselineRect.top) + ( endRect.height / 2 ) - 2;
                height = startRect.top - absoluteTop + 7;
                width = endRect.left - absoluteLeft;
            } else {
                absoluteLeft = startRect.left + ( startRect.width / 2 );
                left = (startRect.left - baselineRect.left) + ( startRect.width / 2 );
                top = (startRect.bottom - baselineRect.top) - 5;
                height = (endRect.top + ( endRect.height / 2 ) ) - startRect.bottom + 4;
                width = endRect.left - absoluteLeft;
            }

            if (height < 3) { // never let height be less than 3 or may not show at all
                height = 3;
            }

            this.setState({
                style: {
                    height: `${height}px`,
                    left: `${left}px`,
                    top: `${top}px`,
                    width: `${width}px`,
                },
            });
        }
    }

    public componentDidMount() {
        window.addEventListener('resize', this.updateDimensions);
        window.addEventListener('customResize', this.updateDimensions);
        this.updateDimensions();
    }

    public componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
        window.removeEventListener('customResize', this.updateDimensions);
    }

    public render() {
        const {
            classes,
            orientation,
            selected,
        } = this.props;

        const classNames = classnames(classes.line, classes.left, {
            [classes.bottom]: orientation === 'bottom',
            [classes.top]: orientation === 'top',
            selected
        });

        return (
            <div className={classNames} style={this.state.style} />
        );
    }
}

export const Line = [
    withStyles(styles),
].reduce((memo, hoc: any) => hoc(memo), LineInner);

export default Line;
